import { supabase } from "./supabase";
import type { Transcript } from "@/types";

export function getTranscriptText(transcript: Transcript): string {
  return transcript.edited_text ?? transcript.raw_text;
}

export async function updateTranscriptText(
  transcriptId: string,
  text: string
): Promise<void> {
  const trimmed = text.trim();
  const { error } = await supabase
    .from("transcripts")
    .update({
      edited_text: trimmed.length > 0 ? trimmed : null,
      edited_at: new Date().toISOString(),
    })
    .eq("id", transcriptId);
  if (error) throw error;
}
